module.exports = __webpack_public_path__ + "img/户用储能2.553d055d.jpg";